import React from 'react';

const TabNavigation = ({ selectedTab, onTabChange }) => {
  const tabs = [
    { id: 'inicio', label: 'Inicio' },
    { id: 'encuentraAbogado', label: 'Encuentra un Abogado' },
    { id: 'consultaExpress', label: 'Consulta Express' },
    { id: 'estadisticas', label: 'Estadísticas de Citas' },
  ];

  return (
    <div className="border-b-2  border-gray-200 bg-white">
      <nav className="px-4">
        <div className="flex overflow-x-auto scrollbar-hide">
          {tabs.map(tab => (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={`py-3 px-4 text-sm whitespace-nowrap transition-colors ${
                selectedTab === tab.id
                  ? 'border-b-4 border-blue-600 text-blue-600 font-medium'
                  : 'text-gray-500 hover:text-gray-700'
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </nav>
    </div>
  );
};

export default TabNavigation;
